export const MAX_RETRY_COUNT = 120;
